import React, {useContext, useMemo} from "react";
import {DataGridStateContext} from "../../../../index";
import DataGridBodyRow from "../row";
import classnames from "classnames";

/**
 * @param {DataGridInternalRow} row
 * @param {boolean} visible
 * @param {Function} startScrolling
 * @param {boolean} alternateColor
 * @param {number} leadingSpacerWidth
 * @param {number} trailingSpacerWidth
 * @param {number} estimateRowHeight
 * @param {number} minRowHeight
 * @param {string[]|undefined} visibleCenterColumnKeys
 * @param {boolean} columnsEnabled
 * @param {function(*): (number|undefined) | undefined} getLockedRowHeight
 */
const DataGridBodyGroupedRows = ({
                                     row,
                                     visible,
                                     startScrolling,
                                     alternateColor = true,
                                     leadingSpacerWidth,
                                     trailingSpacerWidth,
                                     estimateRowHeight,
                                     minRowHeight,
                                     visibleCenterColumnKeys,
                                     columnsEnabled,
                                     getLockedRowHeight,
                                 }) => {
    const {density} = useContext(DataGridStateContext);
    const rows = useMemo(() => row.groupedRows, [row?.groupedRows])

    return (
        <>
            {
                visible &&
                rows.map(nestedRow => (
                    <DataGridBodyRow
                        key={nestedRow.key}
                        density={density}
                        row={nestedRow}
                        className={classnames({'data-grid-grouped-row': alternateColor})}
                        startScrolling={startScrolling}
                        leadingSpacerWidth={leadingSpacerWidth}
                        trailingSpacerWidth={trailingSpacerWidth}
                        estimateRowHeight={estimateRowHeight}
                        minRowHeight={minRowHeight}
                        visibleCenterColumnKeys={visibleCenterColumnKeys}
                        columnsEnabled={columnsEnabled}
                        getLockedRowHeight={getLockedRowHeight}
                    />
                ))
            }
        </>
    )
}

export default DataGridBodyGroupedRows;
